// import PropTypes from "prop-types";
import emptyUser from "./empty_avatar.cedf234c.png";

const Preview = ({ cvData }) => {
  return (
    <main>
      <div className="bg-sky-500 pt-3 text-white pl-2">
        <h1 className="text-4xl font-bold tracking-wider">
          {cvData.personalInfo.firstName} {cvData.personalInfo.lastName}
        </h1>
        <p className="text-xl tracking-wide">{cvData.personalInfo.title}</p>
      </div>
      {/* Grid container */}
      <div className="sm:grid grid-cols-5 gap-0">
        {/*right grid display*/}
        <div className="col-span-2 bg-gray-200">
          {/* image container */}
          <div className="py-6">
            <img
              className="block mx-auto w-40 h-48"
              src={
                !cvData.personalInfo.image
                  ? emptyUser
                  : cvData.personalInfo.image
              }
              alt="profile image"
            />
          </div>
          {/* Personal Details */}
          <section className="block w-60 mx-auto">
            <h2 className="text-xl font-bold border-b border-zinc-400 text-blue-900 tracking-wide">
              Personal Details
            </h2>
            <div className="mt-2">
              <h4 className="text-sm font-bold tracking-wide">Address</h4>
              <p>{cvData.personalInfo.address}</p>
            </div>
            <div className="mt-2">
              <h4 className="text-sm font-bold tracking-wide">Phone Number</h4>
              <p>{cvData.personalInfo.number}</p>
            </div>
            <div className="mt-2">
              <h4 className="text-sm font-bold tracking-wide">Email</h4>
              <p className="break-all">{cvData.personalInfo.email}</p>
            </div>
          </section>
        </div>
        {/*LEFT GRID*/}
        <div className="row-start-1 col-start-1 col-end-4 pl-2 bg-gray-100">
          {/* Description block */}
          <section className="pt-4">
            <h3 className="text-lg font-bold text-blue-900 border-b border-zinc-400 tracking-wider">
              Description
            </h3>
            <p className="">{cvData.personalInfo.description}</p>
          </section>
          {/* Experiences block */}
          <section className="pt-4">
            <h3 className="text-lg font-bold text-blue-900 border-b border-zinc-400 tracking-wider">
              Experience
            </h3>
            <ul>
              {cvData.experience.map((el) => (
                <li key={el.id}>
                  <div className="flex gap-4">
                    <div className="year font-bold">
                      {el.from} - {el.to}
                    </div>
                    <aside>
                      <h4 className="font-bold">{el.company}</h4>
                      <p className="text-sm">Position: {el.position}</p>
                    </aside>
                  </div>
                </li>
              ))}
            </ul>
          </section>
          {/* Education block */}
          <section className="pt-4">
            <h3 className="text-lg font-bold text-blue-900 border-b border-zinc-400 tracking-wider">
              Education
            </h3>
            <ul>
              {cvData.education.map((form) => (
                <li key={form.id}>
                  <div className="flex gap-4">
                    <div className="year font-bold">
                      {form.from} - {form.to}
                    </div>
                    <aside>
                      <h4 className="font-bold">{form.university}</h4>
                      <p className="text-sm">Degree: {form.degree}</p>
                      <p className="text-sm">Subject: {form.subject}</p>
                    </aside>
                  </div>
                </li>
              ))}
            </ul>
          </section>
        </div>
      </div>
    </main>
  );
};

// Preview.propTypes = {
//   states: PropTypes.func,
// };

export default Preview;
